import { ReactNode, useCallback, useEffect, useState } from 'react';
import { DndContext, DragEndEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { isEmpty, map } from 'lodash';
import SortableItem from '@/pages/backend/cardCampSettings/recruitPageSettings/SortableItem';
import { ColumnsType } from 'antd/es/table';
import { Table } from 'antd';
import { RewardSortableItem } from '../rewardSettings';

type DragListProps<T> = {
  disabled?: boolean;
  data: T[];
  extraParams?: any;
  component?: (item: T, index: number) => ReactNode;
  emptyComponent?: () => ReactNode;
  tableProps?: {
    columns: ColumnsType<T>;
  };
  loading?: boolean;
  onDragEnd?: (data: { id: string; index: number }[], extraParams?: any) => void;
};

function DragList<T extends { id: string; [key: string]: any }>(props: DragListProps<T>) {
  const { loading, disabled, tableProps, extraParams, onDragEnd, data, component, emptyComponent } =
    props;
  const [dataSource, setDataSource] = useState<T[]>([]);
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        // https://docs.dndkit.com/api-documentation/sensors/pointer#activation-constraints
        distance: 1,
      },
    }),
  );
  const handleDragEnd = useCallback(
    (event: DragEndEvent) => {
      const { active, over } = event;
      const ids = dataSource.map((item) => item.id);
      const oldIndex = ids.indexOf(active?.id as string);
      const newIndex = ids.indexOf(over!?.id as string);
      if (active?.id !== over?.id) {
        const a = arrayMove(dataSource, oldIndex, newIndex);
        console.log('array move是');
        console.log(a);
        onDragEnd?.(
          a.map((item, index) => ({ id: item.id, index })),
          extraParams,
        );
        setDataSource(a);
      }
    },
    [dataSource, extraParams],
  );
  useEffect(() => {
    setDataSource(data);
  }, [data]);
  return (
    <>
      {Array.isArray(dataSource) && (
        <DndContext
          sensors={sensors}
          modifiers={[restrictToVerticalAxis]}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={dataSource.map((c) => c.id)}
            strategy={verticalListSortingStrategy}
          >
            {!isEmpty(tableProps) ? (
              <Table
                loading={loading}
                rowKey="id"
                components={{ body: { row: RewardSortableItem } }}
                pagination={false}
                columns={tableProps.columns}
                dataSource={dataSource}
              />
            ) : (
              <>
                {dataSource.length === 0 ? (
                  emptyComponent?.()
                ) : (
                  <>
                    {map(dataSource, (item, index) => {
                      return (
                        <SortableItem disabled={disabled} id={item.id} key={item.id}>
                          <div data-id={item.id} key={item.id}>
                            {component?.(item, index)}
                          </div>
                        </SortableItem>
                      );
                    })}
                  </>
                )}
              </>
            )}
          </SortableContext>
        </DndContext>
      )}
    </>
  );
}
export default DragList;
